import { handleCategoryNavigation } from "./routeFunctions";
import base from "./base";
import wordpress from "./wordpress";
import catalog from "./catalog";
import profile from "./profile";
import checkout from "./checkout";
import store from "./store";

const routes = [
  {
    path: "/",
    name: "Home",
    props: true,
    component: () => import("@/views/Home.vue"),
    beforeEnter(to, from, next) {
      handleCategoryNavigation("home-2022", to, from, next);
    }
  },

  ...base,
  ...wordpress,
  ...catalog,
  ...profile,
  ...checkout,
  ...store,

  {
    path: "*",
    name: "DefaultRoute",
    component: () => import("@/views/Home.vue"),
    beforeEnter(to, from, next) {
      handleCategoryNavigation("home-2022", to, from, next);
    }
  }
];

export default routes;
